import { FunctionComponent } from 'react';

import { SettingsColor } from './settings-color';

interface SettingsTextColorProps {}

export const SettingsTextColor: FunctionComponent<SettingsTextColorProps> = () => {
  return <SettingsColor id="text-color" textfieldLabel="Text Color (Hex Code)" type="color" />;
};
